<template>
  <input
    :id="id"
    type="hidden"
    v-bind:value="value"
    v-on:input="$emit('input', $event.target.value)"
  />
</template>

<script>
export default {
  name: "HiddenField.vue",
  props: {
    id: {
      required: true
    },
    value: {}
  }
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/form/HiddenField.vue